<template>
    <div id="app" class="m-app">
        <!-- 顶部导航栏 -->
        <header class="m-header">
            <div class="m-header__brand" @click="hanldClick('')">
                <img src="https://qiniu.shunmingelectronic.com/guanwang/newLogo.png" alt="舜铭电子" class="m-header__logo">
                <img src="https://qiniu.shunmingelectronic.com/guanwang/shunming-text.png" alt="舜铭电子"
                    class="m-header__name">
            </div>
            <div class="m-header__menu-icon" :class="{ 'is-open': menuActive }" @click="toggleMenu">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </header>

        <!-- 菜单遮罩 -->
        <transition name="m-fade">
            <div v-if="menuActive" class="m-overlay" @click="toggleMenu"></div>
        </transition>

        <!-- 菜单选项 -->
        <transition name="m-slide">
            <nav v-if="menuActive" class="m-menu">
                <a class="m-menu__link" @click="hanldClick('')">首页</a>
                <a class="m-menu__link" @click="hanldClick('about')">关于舜铭</a>
                <a class="m-menu__link" href="https://shunmingelectronic.com/meter/"
                    @click="closeMenu">流量计转换器</a>
                <a class="m-menu__link" href="https://shunmingelectronic.com/meter/project#/project"
                    @click="closeMenu">仪表云平台</a>
                <div class="m-menu__group">
                    <div class="m-menu__link m-menu__link--toggle" @click="toggleDropdown(1)">
                        <span>其它产品</span>
                        <span class="m-menu__chev" :class="{ 'is-open': activeDropdown === 1 }">›</span>
                    </div>
                    <transition name="m-collapse">
                        <div v-if="activeDropdown === 1" class="m-menu__sub">
                            <a v-for="(subItem, subIndex) in otherProducts" :key="subIndex"
                                @click="hanldClick('products', { categoryId: subItem.categoryId })">{{
                                    subItem.name }}</a>
                        </div>
                    </transition>
                </div>
                <a class="m-menu__link" @click="hanldClick('contact')">联系我们</a>
                <a class="m-menu__link" href="https://qiniu.shunmingelectronic.com/meter/apk/SMbluetooth.apk"
                    rel="noopener noreferrer">APP 下载</a>
            </nav>
        </transition>

        <!-- 路由视图 -->
        <div class="router-view-container">
            <router-view></router-view>
        </div>

        <!-- 页脚 -->
        <footer class="m-footer">
            <img src="https://qiniu.shunmingelectronic.com/guanwang/newLogo.png" alt="舜铭电子" class="m-footer__logo">
            <p class="m-footer__tagline">精准智控，慧创未来<br>为您提供物联网整体解决方案</p>
            <div class="m-footer__beian">
                <a href="https://beian.miit.gov.cn">豫ICP备2024070819号-1</a>
                <span class="m-footer__gov">
                    <img src="../assets/batb.png" alt="" />
                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41030502000977" rel="noreferrer">豫公网安备41030502000977</a>
                </span>
            </div>
            <div class="m-footer__copy">{{ copyright }}</div>
        </footer>
    </div>
</template>

<script>
import { jumpPage } from '../utils/public';

export default {
    name: 'App',
    data() {
        return {
            gsxx: `ShunMing International`,
            copyright: '版权所有：河南舜铭电子信息科技有限公司 ©2024 ',
            activeDropdown: null,
            menuActive: false,
            otherProducts: [
                { name: '慧光路灯智能云平台', categoryId: 1 },
                { name: '传统行业物联网改造升级', categoryId: 3 }
            ]
        };
    },
    methods: {
        toggleMenu() {
            this.menuActive = !this.menuActive;
            this.activeDropdown = null;
        },
        toggleDropdown(index) {
            this.activeDropdown = this.activeDropdown === index ? null : index;
        },
        hanldClick(path, query) {
            jumpPage(path, query);
            this.closeMenu();
        },
        closeMenu() {
            this.menuActive = false;
            this.activeDropdown = null;
        }
    },
    mounted() {
    }
};
</script>

<style scoped>
.m-app {
    background: var(--bg);
    color: var(--text);
    min-height: 100vh;
    text-align: left;
}

/* ---------------- Header ---------------- */
.m-header {
    width: 100%;
    height: 56px;
    background: rgba(255, 255, 255, 0.82);
    border-bottom: 1px solid var(--border);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
}

.m-header__brand {
    display: flex;
    align-items: center;
    gap: 10px;
}

.m-header__logo {
    height: 28px;
}

.m-header__name {
    height: 18px;
    width: auto;
    display: block;
}

.m-header__menu-icon {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 26px;
    height: 18px;
    cursor: pointer;
}

.m-header__menu-icon span {
    height: 2px;
    width: 100%;
    background-color: var(--text);
    border-radius: 2px;
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.m-header__menu-icon.is-open span:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
}

.m-header__menu-icon.is-open span:nth-child(2) {
    opacity: 0;
}

.m-header__menu-icon.is-open span:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
}

/* ---------------- Menu ---------------- */
.m-overlay {
    position: fixed;
    inset: 56px 0 0 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
}

.m-menu {
    position: fixed;
    top: 56px;
    right: 0;
    width: 76%;
    max-width: 320px;
    height: calc(100vh - 56px);
    background: rgba(255, 255, 255, 0.98);
    border-left: 1px solid var(--border);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    z-index: 999;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow-y: auto;
}

.m-menu__link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--text);
    text-decoration: none;
    font-family: var(--font-display);
    font-size: 17px;
    font-weight: 500;
    padding: 16px 14px;
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.m-menu__link:active {
    background: rgba(15, 18, 24, 0.05);
}

.m-menu__chev {
    color: var(--text-soft);
    font-size: 22px;
    line-height: 1;
    transition: transform 0.25s ease;
}

.m-menu__chev.is-open {
    transform: rotate(90deg);
}

.m-menu__sub {
    display: flex;
    flex-direction: column;
    padding: 4px 0 8px 14px;
}

.m-menu__sub a {
    color: var(--text-soft);
    text-decoration: none;
    font-size: 15px;
    padding: 12px 14px;
    border-radius: 10px;
    cursor: pointer;
}

.m-menu__sub a:active {
    background: rgba(15, 18, 24, 0.05);
    color: var(--text);
}

/* transitions */
.m-fade-enter-active,
.m-fade-leave-active {
    transition: opacity 0.25s ease;
}

.m-fade-enter-from,
.m-fade-leave-to {
    opacity: 0;
}

.m-slide-enter-active,
.m-slide-leave-active {
    transition: transform 0.28s ease;
}

.m-slide-enter-from,
.m-slide-leave-to {
    transform: translateX(100%);
}

.m-collapse-enter-active,
.m-collapse-leave-active {
    transition: opacity 0.2s ease;
}

.m-collapse-enter-from,
.m-collapse-leave-to {
    opacity: 0;
}

/* ---------------- Router view ---------------- */
.router-view-container {
    position: relative;
    z-index: 1;
}

/* ---------------- Footer ---------------- */
.m-footer {
    background: var(--bg-soft);
    border-top: 1px solid var(--border);
    padding: 48px 24px 32px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.m-footer__logo {
    height: 60px;
}

.m-footer__tagline {
    color: var(--text-soft);
    font-size: 14px;
    line-height: 1.7;
    margin: 0;
}

.m-footer__beian {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
}

.m-footer__beian a {
    color: var(--text-faint);
    text-decoration: none;
    font-size: 12px;
}

.m-footer__gov {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.m-footer__gov img {
    width: 14px;
    height: 16px;
}

.m-footer__copy {
    color: var(--text-faint);
    font-size: 12px;
    margin-top: 6px;
}
</style>
